import RedirectIDP from './RedirectIDP'
export default RedirectIDP
